<template>
  <obj-page-container
    :headline="$t('headline.enter_form', {customer: config.brandName})"
    :style="{color:pageTextColor}"
    data-scroll-to="container-form"
  >

    <section class="c-cbr-PageSection-form">
      <obj-form
        :data="formData"
        :rows="formRows"
        :show-errors="showErrors"
        scope="formData"
        @valid="(isValid) => setValid(isValid)"
      />

      <div class="c-cbr-ManualForm-actions">
        <obj-button
          :is-active="formIsValid"
          is-wide
          @click="scrollNext()"
        >{{ $t("btn.find_drop_location") }}</obj-button>
      </div>
    </section>
  </obj-page-container>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import CbrFormField from './CbrFormField.vue'
import ObjButton from './ObjButton.vue'
import ObjForm from './ObjForm.vue'
import ObjPageContainer from './ObjPageContainer.vue'

export default {
  components: {
    CbrFormField,
    ObjButton,
    ObjForm,
    ObjPageContainer
  },

  model: {
    prop: 'formData',
    event: 'update'
  },

  props: {
    formData: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      showErrors: false
    }
  },

  computed: {
    ...mapGetters('config', [
      'countries','returnReasons','pageTextColor'
    ]),
    ...mapGetters('inputData', [
      'formIsValid'
    ]),

    formRows() {
      var reasonType= (this.config.standardReturnReasonsEnabled) ? 'select-reason' : 'text';  //switching bw dropdown or text field
      return [
      [
        {
          id: 'order_number',
          label: 'form.order_number',
          type: 'text',
          validate: 'required|min:3|invalidCharPerCountry:country|orderNumberPerCountry:country',
          classes: ['u-grid', 'is-c-1-1 ']
        }
      ],
      [
        {
          id: 'name',
          label: 'form.name',
          type: 'text',
          autofill: 'name',
          validate: 'required|fullName:country|fullNamePerCountry:country|invalidCharPerCountry:country',
          classes: ['u-grid', 'is-c-1-1 ']
        }
      ],
      [
        {
          id: 'country',
          label: 'form.country',
          help: 'form.country_help',
          type: 'select',
          autofill: 'country',
          options: this.countries,
          validate: 'required',
          ref:'country',
          classes: ['u-grid', 'is-c-1-1']
        }
      ],
      [
        {
          id: 'address',
          label: 'form.street_address',
          type: 'text',
          autofill: 'street-address',
          validate: 'required|min:3|max:40|invalidCharPerCountry:country',
          classes: ['u-grid', 'is-c-1-1 ']
        }
      ],
      [
        {
          id: 'postal_code',
          label: 'form.postal_code',
          type: 'text',
          autofill: 'postal-code',
          validate: 'required|min:1|max:10|zipCodePerCountry:country|blackListZipCodePerCountry:country|invalidCharPerCountry:country',
          classes: ['u-grid', 'is-c-1-2', 'is-xc-1-1']
        },
        {
          id: 'city',
          label: 'form.city',
          type: 'text',
          autofill: 'address-level2',
          validate: 'required|min:2|max:40|invalidCharPerCountry:country',
          classes: ['u-grid', 'is-c-1-2', 'is-xc-1-1']
        }
      ],
      [
        {
          id: 'email',
          label: 'form.email',
          help: 'form.email_help',
          type: 'text',
          autofill: 'email',
          validate: 'emailInput',
          classes: ['u-grid', 'is-c-1-1 ']
        }
      ],
      [
        {
          id: 'return_reason',
          label: 'form.return_reason',
          type: reasonType,
          options_array: this.returnReasons,
          validate: 'required|max:200|invalidCharPerCountry:country',
          classes: ['u-grid', 'is-c-1-1', 'margin-top-5']
        }
      ],
      [
        {
          id: 'return_reason_others',
          label: '',
          type: "text-optional",
          classes: ['u-grid', 'is-c-1-1 ']
        }
      ]
    ]
    }
  },

  methods: {
    ...mapMutations('inputData', [
      'SET_FORM_VALID',
      'SET_FORM_DATA'
    ]),
    ...mapMutations('dropShops', [
      'SET_ADDRESS',
      'SET_COUNTRY'
    ]),
    ...mapActions('dropShops', [
      'searchDropShops'
    ]),

    setValid(isValid) {
      if (isValid) {
        this.SET_FORM_VALID(true);
        this.SET_FORM_DATA(this.formData);
        this.SET_ADDRESS(`${this.formData.address}, ${this.formData.postal_code} ${this.formData.city}`);
        this.SET_COUNTRY(`${this.formData.country}`);
        this.searchDropShops()
      } else {
        this.SET_FORM_VALID(false);
      }
    },

    scrollNext() {
      this.showErrors = true;

      if (this.formIsValid) {
        Vue.nextTick(() => {
          VueScrollTo.scrollTo('[data-scroll-to="container-return-select"]');
        });
      } else {
        const firstError = document.getElementsByClassName('c-cbr-FormField-error')[0];

        if (firstError) {
          firstError.scrollIntoView(true);

          /* First error => align middle */
          var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
          window.scrollBy(0, (-1 * viewportHeight / 2));
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/CbrManualForm.vue